// extracted by mini-css-extract-plugin
export var displayNone = "_rd-6";
export var imgContainer = "_rd-2";
export var overflowHidden = "_rd-3";
export var productInfoCardButtonContainer = "_rd-5";
export var productTitleText = "_rd-4";
export var rightArrow = "_rd-1";
export var rightArrowContainer = "_rd-0";